module.exports = __webpack_public_path__ + "static/05-9f7fe2c0d9ae99252f705e2f8e6ae889.jpg";